export default __webpack_public_path__ + "static/media/moon.b4a36b55.svg";